import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow.svg'
import _imports_1 from '@/assets/arrow_blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-6ebe2b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "expore_more" }
const _hoisted_2 = { class: "solution_label" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "solution_content_center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "solution_content_right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "01.", -1))
const _hoisted_8 = { class: "option_right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "02.", -1))
const _hoisted_11 = { class: "option_right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "03.", -1))
const _hoisted_14 = { class: "option_right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_16 = { class: "service_header" }
const _hoisted_17 = { class: "service_header_title" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "service_body_left" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/liquid_cooling_service.jpg",
  alt: "",
  class: "service_thumbnail"
}, null, -1))
const _hoisted_21 = { class: "service_body_left_mask" }
const _hoisted_22 = { class: "describe" }
const _hoisted_23 = { class: "service_body_right" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/AIGC_infrastructure.jpeg",
  alt: "",
  class: "service_thumbnail"
}, null, -1))
const _hoisted_25 = { class: "service_body_right_mask" }
const _hoisted_26 = { class: "describe" }
const _hoisted_27 = { class: "product" }
const _hoisted_28 = { class: "product_content_left" }
const _hoisted_29 = { class: "product_content_left_title" }
const _hoisted_30 = { class: "describe_content" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "product_content_scroller" }
const _hoisted_33 = { class: "product_content_scroller_items" }
const _hoisted_34 = { class: "item_thumbnail" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "item_label" }
const _hoisted_37 = { class: "company_content_left" }
const _hoisted_38 = { class: "company_content_left_title" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "company_content_right" }
const _hoisted_41 = { class: "company_content_right_thumbnail" }
const _hoisted_42 = ["src"]

import routeHash from "@/constant/router_hash";
import provide_key from "@/constant/provide_key";
import Mitt from "@/utils/mitt";
import { useI18n } from "vue-i18n";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { ref, onMounted, inject, computed } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExporeMore',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
gsap.registerPlugin(ScrollTrigger);

const progress = ref(0);
const currentIndex = ref(0);
const shrink: boolean | undefined = inject(provide_key.SHRINK);

const solutionUrls = ref([
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/why_liquid_cooling.png",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/liquid_cooling_service.png",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/retorift.png",
]);

const aboutUsUrls = ref([
   "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_1.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_2.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_3.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_4.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_5.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_6.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_7.jpg",
]);

const currentAboutIndex = ref(0);

const onJumpTo = (hash: any) => {
  setTimeout(() => Mitt.emit(hash), 0);
  switch (hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" });
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" });
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product" });
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" });
      return;
    default:
      return;
  }
};

onMounted(() => {
    setInterval(() => {
    currentAboutIndex.value = (currentAboutIndex.value + 1) % aboutUsUrls.value.length; // 更新当前索引
  }, 2000); 
  const t1 = gsap.timeline({
    scrollTrigger: {
      trigger: ".main",
      start: "top bottom", // Start the animation when the top of thumbnail_box enters the viewport
      end: `bottom top`, // End the animation when the bottom of thumbnail_box reaches the top of the viewport
      scrub: true,
    },
  });

  const t2 = gsap.timeline({
    scrollTrigger: {
      trigger: ".product",
      start: "top top",
      end: "bottom top",
      pin: true,
      pinType: "fixed",
      pinnedContainer: ".main",
      pinSpacing: true,
      scrub: 0.01,
      onUpdate: (self) => {
        if (self.progress < 1) {
          progress.value = Math.floor(self.progress / 0.25);
        }
      },
    },
  });

  const t3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".service",
      start: "50% bottom",
      end: "bottom top",
      scrub: 0.001,
    },
  });

  t2.to(".product_content_scroller_items", {
    duration: 2,
    y: "-75%",
    ease: "none",
  });
  t1.to(".thumbnail_box", { y: "100vh" });
  t3.fromTo(".service_thumbnail", { y: "0" }, { y: "20%"});

  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % solutionUrls.value.length;
  }, 2000);
});

const products = computed(() => [
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2L_CDU_front.png",
    label: t("home.HOME_PRODUCT_L2L"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_front.png",
    label: t("home.HOME_PRODUCT_L2A"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/near_door_thumbnail_back.png",
    label: t("home.HOME_PRODUCT_RDHx"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others1_single.png",
    label: t("home.HOME_PRODUCT_OTHER"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
]);

const onReadMore = () => {
  const productHashList = [
    routeHash.L2A_PRODUCT,
    routeHash.L2L_PRODUCT,
    routeHash.RDHx_PRODUCT,
    routeHash.OTHERS_PRODUCT,
  ];
  onJumpTo(productHashList[progress.value])
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _directive_translateIn = _resolveDirective("translateIn")!
  const _directive_slideIn = _resolveDirective("slideIn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "solution",
      style: _normalizeStyle({ padding: _unref(shrink) ? '4rem 2rem' : '4rem 0' })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t("home.HOME_SOLUTION_TITLE")), 1)
      ])), [
        [_directive_translateIn]
      ]),
      _createElementVNode("div", {
        class: "solution_describe",
        innerHTML: _ctx.$t('home.HOME_SOLUTION_DESCRIPTION')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        class: "solution_content",
        style: _normalizeStyle({
          'flex-direction': _unref(shrink) ? 'column' : 'row',
        })
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solutionUrls.value, (imgUrl, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "thumbnail",
              key: imgUrl
            }, [
              _createVNode(_Transition, {
                name: "scaleIn",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (index === currentIndex.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imgUrl,
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "option",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onJumpTo(_unref(routeHash).AIR_TO_LIQUID_COOLING)))
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_SOLUTION_TAG_1")), 1),
              _hoisted_9
            ])
          ])), [
            [_directive_slideIn, _unref(shrink) ? 'none' : 'right']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "option",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onJumpTo(_unref(routeHash).SYSTEMIC_LIQUID_COOLING)))
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_SOLUTION_TAG_2")), 1),
              _hoisted_12
            ])
          ])), [
            [_directive_slideIn, _unref(shrink) ? 'none' : 'right']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "option",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onJumpTo(_unref(routeHash).RDHX_AIR_COOLED)))
          }, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_SOLUTION_TAG_3")), 1),
              _hoisted_15
            ])
          ])), [
            [_directive_slideIn, _unref(shrink) ? 'none' : 'right']
          ])
        ])
      ], 4)
    ], 4),
    _createElementVNode("div", {
      class: "service",
      style: _normalizeStyle({ padding: _unref(shrink) ? '4rem 2rem' : '4rem 0' })
    }, [
      _createElementVNode("div", _hoisted_16, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.$t("home.HOME_SERVICE")), 1)
        ])), [
          [_directive_translateIn]
        ]),
        _createElementVNode("div", {
          class: "service_header_describe",
          innerHTML: _ctx.$t('home.HOME_SERVICE_TITLE')
        }, null, 8, _hoisted_18)
      ]),
      _createElementVNode("div", {
        class: "service_body",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
      }, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)(`service.LIQUID_COOLING_SERVICE`)), 1),
            _createElementVNode("div", {
              class: "service_body_left_mask_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onJumpTo(_unref(routeHash).IDC_LIQUID_COOLING)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_SERVICE_BTN")), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#fff",
                class: "arrow_left"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)(`service.AIGC_INFRASTRUCTURE`)), 1),
            _createElementVNode("div", {
              class: "service_body_right_mask_btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (onJumpTo(_unref(routeHash).AIGC_INFRASTRUCTURE)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_SERVICE_BTN")), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#fff",
                class: "arrow_left"
              })
            ])
          ])
        ])
      ], 4)
    ], 4),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", {
        class: "product_content",
        style: _normalizeStyle({
          'flex-direction': _unref(shrink) ? 'column-reverse' : 'row',
          padding: _unref(shrink) ? '0' : '0 3rem',
        })
      }, [
        _createElementVNode("div", _hoisted_28, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createTextVNode(_toDisplayString(_ctx.$t("home.HOME_PRODUCT_TITLE")), 1)
          ])), [
            [_directive_translateIn]
          ]),
          (_openBlock(), _createElementBlock("div", {
            class: "product_content_left_describe",
            key: progress.value
          }, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(products.value[progress.value].describe), 1)
          ])),
          _createElementVNode("div", {
            class: "read_more",
            onClick: onReadMore
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.HOME_READ_MORE")), 1),
            _hoisted_31
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: product.assetUrl
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("img", {
                    src: product.assetUrl,
                    alt: ""
                  }, null, 8, _hoisted_35)
                ]),
                _createElementVNode("div", _hoisted_36, _toDisplayString(product.label), 1)
              ]))
            }), 128))
          ])
        ])
      ], 4)
    ]),
    _createElementVNode("div", {
      class: "company",
      style: _normalizeStyle({ padding: _unref(shrink) ? '4rem 2rem' : '4rem 0' })
    }, [
      _createElementVNode("div", {
        class: "company_content",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
      }, [
        _createElementVNode("div", _hoisted_37, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createTextVNode(_toDisplayString(_ctx.$t("home.HOME_COMPANY_TITLE")), 1)
          ])), [
            [_directive_translateIn]
          ]),
          _createElementVNode("div", {
            class: "company_content_left_describe",
            innerHTML: _ctx.$t('home.HOME_COMPANY_DESCRIBE')
          }, null, 8, _hoisted_39),
          _createElementVNode("div", {
            class: "company_content_left_btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onJumpTo(_unref(routeHash).CONTACT_US)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.BUTTON_TEXT")), 1),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#25488f",
              class: "arrow_left"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("img", {
              src: aboutUsUrls.value[currentAboutIndex.value],
              alt: ""
            }, null, 8, _hoisted_42)
          ])
        ])
      ], 4)
    ], 4)
  ]))
}
}

})